import React from 'react';
import {useTranslation} from 'react-i18next';
import SectionWrapper from './section-wrapper';

const whatIsClubImage = require('@/pages/agent/assets/what-is-club.webp');

const ClubExplanation: React.FC = () => {
  const {t} = useTranslation();

  return (
    <SectionWrapper title={t('agent.rules.clubExplanation.title')}>
      {/* 俱乐部说明文本 */}
      <p className="text-xs font-medium text-black">
        {t('agent.rules.clubExplanation.description')}
      </p>

      {/* 俱乐部图片 */}
      <img src={whatIsClubImage} alt="What is Club" className="w-full h-auto" />
    </SectionWrapper>
  );
};

export default ClubExplanation;
